<template>
  <div class="payContainer">
    <el-row class="top">
      <el-col class="title" :span="12">您好，{{ name }}</el-col>
      <el-col class="fr info" :span="12">
        <span class="infoBtn">订单信息</span>
        <span class="infoBtn">账户信息</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="title">选择支付方式</div>
      <div class="tips">
        下单购买 X5
        的第一笔付款金额为￥1.000，该笔付款不可退款，不可转让。支付第一笔付款后，奕优工作人员会与您联系并安排后续事宜。
      </div>
      <div class="payType">
        <button :class="'item'">对公转账</button>
        <button class="item">
          <img
            class="aliPayImg"
            :src="require('../../images/aliPay.png')"
            alt=""
          />
          支付宝
        </button>
        <button class="item">
          <img
            class="weChatImg"
            :src="require('../../images/wechatPay.png')"
            alt=""
          />
          微信支付
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeType: 1,
      name: this.$store.state.user.name
    };
  },
  mounted() {
    this.$store.commit("edit_backgroundColor", "#3e3e3e");
  },
  destroyed() {
    this.$store.commit("edit_backgroundColor", "rgba(0, 0, 0, 1)");
  }
};
</script>

<style lang="less">
.payContainer {
  max-width: 1020px;
  padding: 60px 16px 0;
  margin: 62px auto;
  .content {
    padding-top: 40px;
    .title {
      font-size: 20px;
      margin-bottom: 8px;
    }
    .payType {
      display: flex;
      margin-top: 16px;
      .item {
        flex: 1;
        height: 50px;
        background: rgba(255, 255, 255, 0);
        border-radius: 2px;
        border: 2px solid #87888b;
        margin-right: 30px;
        opacity: 0.5;
        .aliPayImg {
          width: 30px;
          height: 30px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 4px;
        }
        .weChatImg {
          width: 30px;
          height: 30px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 4px;
        }
      }
      .active {
        opacity: 1;
      }
      .item:last-child {
        margin-right: 0;
      }
    }
  }
  .top {
    padding-bottom: 24px;
    border-bottom: 1px solid #d8d8d8;
    .title {
      font-size: 24px;
    }
    .info {
      text-align: right;
      padding-top: 10px;
    }
    .infoBtn {
      margin-left: 24px;
      cursor: pointer;
    }
  }
}
</style>
